import React, { Component } from 'react';
import CounterInput from "react-counter-input";

// import { Container } from './styles';

export default class Input extends Component {


    renderInput = () => {

        return (
            <>
                {this.props.type === 'textarea' ?
                    (<div className="gb-textarea"><textarea
                        autoComplete="off"

                        type={this.props.type}
                        className="form-control"
                        id={this.props.id}
                        disabled={this.props.disabled}
                        placeholder={this.props.placeholder}
                        value={this.props.value}
                        rows={this.props.rows}
                        onChange={text => { this.props.onChange(text.target.value) }}
                        onKeyPress={ev => { if (this.props.onKeyPress) { this.props.onKeyPress(ev) } }}

                    >{this.props.value} </textarea></div>)
                    : this.props.type === 'count' ?
                        (<CounterInput
                            count={this.props.initialValue}
                            className="form-control"
                            min={this.props.inseridos ? this.props.inseridos : 0}
                            max={95}
                            onCountChange={value => { this.props.onChange(value) }}
                        />)
                        :
                        (
                            <input
                                autoComplete="off"
                                type={this.props.type}
                                className="form-control"
                                id={this.props.id}
                                disabled={this.props.disabled}
                                placeholder={this.props.placeholder}
                                value={this.props.value}
                                onChange={text => { this.props.onChange(text.target.value) }}
                                onKeyPress={ev => { if (this.props.onKeyPress) { this.props.onKeyPress(ev) } }}
                            />

                        )
                }
            </>
        )
    }

    renderOldInput = () => {
        return (
            <div className="form-group row">
                <label className={`col-sm-${this.props.sz === 1 ? 12 : 3} control-label`}>{this.props.label}</label>
                <div className={`col-sm-${this.props.sz === 1 ? 12 : 9} `}>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                                <i className={this.props.icone}></i>
                            </span></div>

                        {this.renderInput()}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (<>
            {(this.props.noForm) ? this.renderInput() : this.renderOldInput()}
        </>
        );
    }
}
